export default "__VITE_ASSET__6dc1ac5c__"